import type { Sender } from "./transport";

/** The slice of `navigator` this needs — injected, so the fallback path is testable off-browser. */
export interface BeaconNavigator {
  sendBeacon?: (url: string, data: Blob) => boolean;
}

/**
 * `sendBeacon` first: it is the only send that reliably survives the page going away, which is
 * exactly when the last and most interesting chunk of a session is written. It refuses when the
 * browser's queue is full, and `keepalive` covers that case with the same semantics.
 */
export function createBeaconSender(nav: BeaconNavigator, fetchFn: typeof fetch | undefined): Sender {
  return (url, body) => {
    const blob = typeof Blob === "undefined" ? null : new Blob([body], { type: "application/json" });
    if (blob && nav.sendBeacon?.(url, blob)) return;
    // Errors are swallowed rather than surfaced: telemetry must never become a symptom the user sees.
    void fetchFn?.(url, {
      method: "POST",
      body,
      keepalive: true,
      headers: { "content-type": "application/json" },
    }).catch(() => undefined);
  };
}
